"use strict";
/**
 * @module Services.MetricCollectors
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var topic_metric_collector_list_1 = require("./../../services/metric-collectors/topic-metric-collector-list");
var topic_metric_collector_serialiser_1 = require("./../../services/metric-collectors/topic-metric-collector-serialiser");
/**
 * Serialiser for {@link TopicMetricCollectorList}
 */
var TopicMetricCollectorListSerialiserClass = /** @class */ (function (_super) {
    __extends(TopicMetricCollectorListSerialiserClass, _super);
    function TopicMetricCollectorListSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link TopicMetricCollector} from the stream
     *
     * @param bis  the input stream
     * @return     the instance that was read
     */
    TopicMetricCollectorListSerialiserClass.prototype.read = function (bis) {
        var collectors = Codec.readCollection(bis, topic_metric_collector_serialiser_1.TopicMetricCollectorSerialiser.read);
        return new topic_metric_collector_list_1.TopicMetricCollectorListImpl(collectors);
    };
    /**
     * Write a {@link TopicMetricCollector} to the stream
     *
     * @param bos    the output stream
     * @param value  the instance to be written
     */
    TopicMetricCollectorListSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeCollection(bos, value.collectors, topic_metric_collector_serialiser_1.TopicMetricCollectorSerialiser.write);
    };
    return TopicMetricCollectorListSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.TopicMetricCollectorListSerialiserClass = TopicMetricCollectorListSerialiserClass;
/**
 * The singleton
 */ // tslint:disable-next-line:variable-name
exports.TopicMetricCollectorListSerialiser = new TopicMetricCollectorListSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metric-collectors/topic-metric-collector-list-serialiser.js
// module id = 1406
// module chunks = 0